import { WorkOrder } from '@/core/domain/workorder/WorkOrders/WorkOrders.types';
import { Form } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React, { useEffect } from 'react';

interface Props {
  workorderData?: WorkOrder;
}

const InspectionRecordHeader: React.FC<Props> = ({ workorderData }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (workorderData) {
      form.setFieldsValue({
        vehicleName: `${workorderData?.vehicle?.brand || ''} ${
          workorderData?.vehicle?.model || ''
        }`,
        licensePlate: workorderData?.vehicle?.licensePlate,
      });
    }
  }, [workorderData]);

  return (
    <Form form={form}>
      <table className="vehicle-info">
        <thead>
          <tr>
            <th>Veículo</th>
            <th>Placa</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              <Form.Item noStyle name="vehicleName">
                <TextArea rows={1} />
              </Form.Item>
            </td>

            <td>
              <Form.Item noStyle name="licensePlate">
                <TextArea rows={1} />
              </Form.Item>
            </td>
          </tr>
        </tbody>
      </table>
    </Form>
  );
};

export default InspectionRecordHeader;
